import styles from "../../scss/pageComponent/checkoutCart.module.scss";
import { InputField } from "../../common/theme/Input";
import { useFormik } from "formik";
import { couponCodeFormSchema } from "../../validations/CheckoutSchema";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetch from "../../customHook/useFetch";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setCartCount } from "../../redux/cart";
import { setCheckoutOrderSummarySlice } from "../../redux/CheckoutForm/CheckoutFormSlice";
import { RotatingLines } from "react-loader-spinner";
import { KeyboardArrowDown } from "@mui/icons-material";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import ComplexGrid from "./CheckoutBundelInfo";
import AppButton from "../../common/theme/Button";
import { Decrypt } from "../../common/utils/Functions";
import {
  buildCartDisplayEntries,
  ensureCartLineIds,
  getBundleDisplayLabel,
  getBundleLineSubtotal,
  getIncludedInBundleText,
  shouldCountAttachedSinglePrices,
  shouldCountBundleProductPrices,
} from "../../common/utils/cartLineHelpers";
import {
  acceptCartLineChange,
  fetchCartStoreChanges,
  removeCartLineById,
} from "../../common/utils/cartStoreChanges";
import type { CartLineChange } from "../../common/utils/cartStoreChanges";
import noteStyles from "../../scss/common/cartItemChangeNote.module.scss";
interface IProps {
  idOfStore?: any;
  orgId?: any;
  summaryData?: any;
  data?: any;
  selected?: any;
  grandTotal: number;
  grandTotalCopy: number;
  setGrandTotal: any;
  setGrandTotalCopy: any;
  onPendingStoreChanges?: (pending: boolean) => void;
}
// let TotalAmount: any = "500";
// let subTotal: any = TotalAmount;

const DiscountAmount: any = {
  name: "Discount",
  price: "0.00",
};

const CheckoutOrderSummary = ({
  orgId,
  idOfStore,
  summaryData,
  data,
  selected,
  grandTotal,
  grandTotalCopy,
  setGrandTotal,
  setGrandTotalCopy,
  onPendingStoreChanges,
}: IProps) => {
  const storeData = useSelector((state: any) => state.storeDataSlice.data);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [storeChanges, setStoreChanges] = useState<Record<string, CartLineChange>>({});
  const [cartLoaded, setCartLoaded] = useState(false);
  const [changesReady, setChangesReady] = useState(false);
  const customerInformation = useSelector(
    (state: any) => state.storeCheckoutForm.FirstFormSlice
  );
  const shippingMethod = useSelector(
    (state: any) => state.storeCheckoutForm.SecondFormSlice
  );
  const payment = useSelector(
    (state: any) => state.storeCheckoutForm.ThirdFormSlice
  );
  const [reLoadCart, setReLoadCart] = useState(false);
  const [discount, setDiscount] = useState(DiscountAmount);
  const [couponId, setCouponId] = useState(0);
  const [showDiscountTab, setShowDiscountTab] = useState(false);
  const [dataOfPrice, setdataOfPrice] = useState([
    {
      name: "Sales Tax",
      price: "0.00",
    },
    {
      name: "Shipping Fee",
      price: "0.00",
    },
    {
      name: "Processing Fee",
      price: "0.00",
    },
    {
      name: "Rush Shipping Fee",
      price: "0.00",
    },
    {
      name: "Rush Shipping Fee",
      price: "0.00",
    },
  ]);

  const [couponCode, setCouponCode] = useState("");
  const [showProcessingFee, setShowProcessingFee] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState<any>(null);
  const [totalAmount, setTotalAmount] = useState(0);

  const [subTotal, setsubTotal] = useState(0);
  const [totalFee, setTotalFee] = useState(0);
  const cartDataInfoD = localStorage?.getItem("cart");
  const cartDataInfo = Decrypt(cartDataInfoD);
  const cartOldData = cartDataInfo ? JSON.parse(cartDataInfo) : [];
  const [bundleData, setBundleData] = useState<any>([]);
  const [orderSummaryEntries, setOrderSummaryEntries] = useState<any[]>([]);
  const [showShipping, setShowShipping] = useState(true);
  const [showRushShipping, setShowRushShipping] = useState(false);
  const [shippingSelection, setShippingSelection] = useState("1");
  const [loaderApplyCoupon, setLoaderApplyCoupon] = useState(false);
  const bundleCount = (bundleData || []).filter(
    (item: any) => !item?.isSingleProduct
  ).length;
  const isPerBundleFeeApplied = bundleCount > 0;

  const getBundleSubtotal = (bundleItem: any, allRows: any[]) =>
    getBundleLineSubtotal(allRows, bundleItem, storeData?.payment_handle_type);

  const getProcessingFeeLineCount = (cartRows: any[]) => {
    const hasBundle = (cartRows || []).some((item: any) => !item?.isSingleProduct);
    if (!hasBundle) return 1;
    const bundleRows = (cartRows || []).filter((item: any) => !item?.isSingleProduct);
    const standaloneRows = (cartRows || []).filter(
      (item: any) =>
        item?.isSingleProduct &&
        (item?.parentBundleLineId == null || item?.parentBundleLineId === "")
    );
    const standaloneSubTotal = standaloneRows.reduce(
      (acc: number, row: any) =>
        acc + Number(row?.club_price || 0) * Number(row?.quantity || 0),
      0
    );
    return (
      bundleRows.reduce(
        (acc: number, bundleItem: any) => acc + Number(bundleItem?.quantity || 1),
        0
      ) + (standaloneSubTotal > 0 ? 1 : 0)
    );
  };

  const calcProcessingFee = (merchandiseBase: number, lineCount: number) => {
    if (Number(merchandiseBase || 0) === 0) return 0;
    return (Number(merchandiseBase) * 2.9) / 100 + 0.3 * Number(lineCount || 0);
  };

  useEffect(() => {
    const shippingMethodType = Number(storeData?.shipping_method_type ?? 0);
    // Any enabled shipping method (Flat Fee, Percentage, UPS) applies for all store types
    if (shippingMethodType !== 0) {
      setShowShipping(true);
    } else {
      setShowShipping(false);
    }
  }, [data, storeData]);

  useEffect(() => {
    const cartDataInfoD = localStorage?.getItem("cart");
    const cartDataInfo = Decrypt(cartDataInfoD);
    const cartData = cartDataInfo ? JSON.parse(cartDataInfo) : [];
    ensureCartLineIds(cartData);
    setBundleData(cartData);
    setCartLoaded(true);
  }, [reLoadCart]);

  useEffect(() => {
    let cancelled = false;
    if (!cartLoaded) return;
    const storeId = storeData?.id;
    if (!bundleData?.length || !storeId) {
      setStoreChanges({});
      setChangesReady(true);
      return;
    }
    setChangesReady(false);
    fetchCartStoreChanges(storeId, bundleData)
      .then((lines) => {
        if (cancelled) return;
        const next: Record<string, CartLineChange> = {};
        lines.forEach((line) => {
          next[String(line.cart_line_id)] = line;
        });
        setStoreChanges(next);
      })
      .catch(() => {
        if (!cancelled) setStoreChanges({});
      })
      .finally(() => {
        if (!cancelled) setChangesReady(true);
      });
    return () => {
      cancelled = true;
    };
  }, [bundleData, storeData?.id, cartLoaded]);

  useEffect(() => {
    const pending =
      !cartLoaded || !changesReady || Object.keys(storeChanges).length > 0;
    onPendingStoreChanges?.(pending);
  }, [cartLoaded, changesReady, storeChanges, onPendingStoreChanges]);

  const hasPendingStoreChanges = Object.keys(storeChanges).length > 0;

  const acceptStoreChange = (cartLineId: string | number) => {
    const line = storeChanges[String(cartLineId)];
    if (!line) return;
    const nextCart = acceptCartLineChange(cartLineId, line);
    dispatch(setCartCount(nextCart.length));
    toast.success("Cart updated with the latest item details");
    setReLoadCart(!reLoadCart);
  };

  const removeChangedItem = (cartLineId: string | number) => {
    const nextCart = removeCartLineById(cartLineId);
    dispatch(setCartCount(nextCart.length));
    toast.success("Removed successfully");
    setReLoadCart(!reLoadCart);
    if (!nextCart.length) navigate("/cart");
  };

  useEffect(() => {
    const entries = buildCartDisplayEntries(bundleData || []);
    setOrderSummaryEntries(entries);
  }, [bundleData]);

  useEffect(() => {
    if (bundleData) {
      let totalPrice = 0;
      let totalItem = 0;
      const payType = storeData?.payment_handle_type;
      bundleData.map((cartItem: any) => {
        if (cartItem.isSingleProduct) {
          if (cartItem.parentBundleLineId == null || cartItem.parentBundleLineId === "") {
            totalPrice += cartItem.club_price * cartItem.quantity;
            totalItem += cartItem.quantity;
          }
        } else if (
          shouldCountBundleProductPrices(payType) ||
          shouldCountAttachedSinglePrices(payType)
        ) {
          totalPrice += getBundleLineSubtotal(bundleData, cartItem, payType);
          if (shouldCountBundleProductPrices(payType)) {
            cartItem.bundle_products?.forEach((product: any) => {
              totalItem += product.store_product_detail.quantity;
            });
          }
          if (shouldCountAttachedSinglePrices(payType)) {
            bundleData
              .filter(
                (row: any) =>
                  row?.isSingleProduct &&
                  row.parentBundleLineId != null &&
                  row.parentBundleLineId !== "" &&
                  Number(row.parentBundleLineId) === Number(cartItem.cartLineId)
              )
              .forEach((row: any) => {
                totalItem += Number(row.quantity || 0);
              });
          }
        }
      });
      setsubTotal(totalPrice);
      setTotalAmount(totalPrice);
    }
  }, [bundleData, couponCode, storeData?.payment_handle_type]);

  useEffect(() => {
    const sale_tax = dataOfPrice[0].price;
    const processing_fee = dataOfPrice[2].price;
    const shippingFeeAmount = Number(
      dataOfPrice.find((item: any) => item.name === "Shipping Fee")?.price || 0
    );
    const rushFeeAmount = dataOfPrice
      .filter((item: any) => item.name === "Rush Shipping Fee")
      .reduce((sum: number, item: any) => sum + Number(item.price || 0), 0);
    const ship_to_home = shippingFeeAmount + rushFeeAmount;
    const offerRushShipping =
      Number(summaryData?.is_offer_rush_shipping || 0) === 1;
    const rushSelected = offerRushShipping && shippingSelection === "2";
    let used_coupon_amount = 0;
    if (couponId) {
      if (selectedCoupon?.type === 1 || selectedCoupon?.type === 2) {
        used_coupon_amount =
          Number(totalAmount) - Number(discount?.price) > 0
            ? Number(discount?.price)
            : totalAmount;
      } else if (selectedCoupon?.type === 3 || selectedCoupon?.type === 4) {
        used_coupon_amount =
          Number(totalAmount) + Number(totalFee) - Number(discount?.price) > 0
            ? Number(discount?.price)
            : Number(totalAmount) + Number(totalFee);
      }
    } else {
      used_coupon_amount = 0;
    }

    const orderSummary = {
      org_id: orgId,
      store_id: idOfStore,
      coupon_id: couponId,
      coupon_code: couponCode,
      coupon_amount: discount?.price
        ? parseFloat(discount.price.toString()).toFixed(2)
        : 0,
      total_amount: parseFloat(grandTotal.toString()).toFixed(2),
      company_bear_amount: couponId
        ? Number(grandTotalCopy) < 0.5
          ? parseFloat(grandTotalCopy.toString()).toFixed(2)
          : 0
        : 0,
      used_coupon_amount: used_coupon_amount,
      sub_total: parseFloat(subTotal.toString()).toFixed(2),
      sale_tax: parseFloat(sale_tax.toString()).toFixed(2),
      processing_fee: parseFloat(processing_fee.toString()).toFixed(2),
      ship_to_home: parseFloat(ship_to_home.toString()).toFixed(2),
      is_offer_rush_shipping: rushSelected ? 1 : 0,
      couponDetail: selectedCoupon,
    };
    dispatch(setCheckoutOrderSummarySlice(orderSummary));
  }, [
    subTotal,
    discount,
    totalFee,
    couponCode,
    grandTotal,
    grandTotalCopy,
    selectedCoupon,
    totalAmount,
    dataOfPrice,
    summaryData,
    shippingSelection,
  ]);

  useEffect(() => {
    const dataOfPriceCopy: any = [
      { name: "Sales Tax", price: "0.00" },
      { name: "Shipping Fee", price: "0.00" },
      { name: "Processing Fee", price: "0.00" },
      { name: "Rush Shipping Fee", price: "0.00" },
    ];

    const hasBundle = (bundleData || []).some((item: any) => !item?.isSingleProduct);
    const bundleRows = (bundleData || []).filter((item: any) => !item?.isSingleProduct);
    const standaloneRows = (bundleData || []).filter(
      (item: any) =>
        item?.isSingleProduct &&
        (item?.parentBundleLineId == null || item?.parentBundleLineId === "")
    );
    const standaloneSubTotal = standaloneRows.reduce(
      (acc: number, row: any) =>
        acc + Number(row?.club_price || 0) * Number(row?.quantity || 0),
      0
    );

    let saleTax = 0;
    let shippingFee = 0;
    let processingFee = 0;
    let rushShippingFee = 0;
    const customFeeById: any = {};

    const isSingleProduct = bundleData?.find((item: any) => item?.isSingleProduct);
    const canChargeProcessingFee =
      summaryData?.is_charge_processing_fee_type === 1 &&
      (summaryData?.payment_handle_type === 1 ||
        (summaryData?.payment_handle_type === 3 && isSingleProduct !== undefined));

    if (
      summaryData.is_charge_processing_fee_type === 2 ||
      summaryData.is_charge_processing_fee_type === 0
    ) {
      setShowProcessingFee(false);
    } else {
      setShowProcessingFee(canChargeProcessingFee);
    }
    const offerRushShipping =
      Number(summaryData?.is_offer_rush_shipping || 0) === 1;
    const rushSelected = offerRushShipping && shippingSelection === "2";
    setShowRushShipping(rushSelected);

    // Any enabled shipping method (Flat Fee, Percentage, UPS) applies for all store types
    const shippingFeeType = Number(summaryData?.shipping_fee_type ?? 0);
    const shouldApplyShippingFee = shippingFeeType !== 0;

    const applyFeesForSubtotal = (lineSubtotal: number, lineCount: number) => {
      if (summaryData.tax_type === 1 || summaryData.tax_type === 2) {
        saleTax += (Number(summaryData.tax || 0) * Number(lineSubtotal || 0)) / 100;
      }

      if (shouldApplyShippingFee && !rushSelected) {
        if (summaryData.shipping_fee_type === 1) {
          shippingFee += Number(summaryData.shipping_amount || 0) * Number(lineCount || 0);
        } else if (summaryData.shipping_fee_type === 2) {
          shippingFee +=
            (Number(summaryData.shipping_amount || 0) * Number(lineSubtotal || 0)) / 100;
        }
      }

      if (rushSelected) {
        rushShippingFee +=
          Number(summaryData?.rush_shipping_fee || 0) * Number(lineCount || 0);
      }

      (summaryData.store_fees || []).forEach((val: any) => {
        const feeId = val?.fee_id;
        const existing = customFeeById[feeId] || {
          fee_id: feeId,
          name: val?.fee_detail?.name,
          price: 0,
        };
        if (val?.fee_detail?.type == 2) {
          existing.price += Number(val?.fee_detail?.amount || 0) * Number(lineCount || 0);
        } else {
          existing.price +=
            (Number(val?.fee_detail?.amount || 0) * Number(lineSubtotal || 0)) / 100;
        }
        customFeeById[feeId] = existing;
      });
    };

    if (hasBundle) {
      bundleRows.forEach((bundleItem: any) => {
        const bundleSubtotal = getBundleSubtotal(bundleItem, bundleData || []);
        const bundleUnits = Number(bundleItem?.quantity || 1);
        applyFeesForSubtotal(bundleSubtotal, bundleUnits);
      });
      if (standaloneSubTotal > 0) {
        applyFeesForSubtotal(standaloneSubTotal, 1);
      }
    } else {
      applyFeesForSubtotal(subTotal, 1);
    }

    if (canChargeProcessingFee) {
      const isSubtotalCoupon =
        (selectedCoupon?.type === 1 || selectedCoupon?.type === 2) &&
        couponCode !== "";
      const discountAmt = isSubtotalCoupon
        ? Number(discount?.price || DiscountAmount.price || 0)
        : 0;
      const merchandiseTotal =
        bundleRows.reduce(
          (acc: number, bundleItem: any) =>
            acc + getBundleSubtotal(bundleItem, bundleData || []),
          0
        ) + standaloneSubTotal;
      const processingFeeBase = Math.max(0, merchandiseTotal - discountAmt);
      processingFee = calcProcessingFee(
        processingFeeBase,
        getProcessingFeeLineCount(bundleData || [])
      );
    }

    dataOfPriceCopy[0].price = saleTax;
    dataOfPriceCopy[1].price = shippingFee;
    dataOfPriceCopy[2].price = processingFee;
    dataOfPriceCopy[3].price = rushShippingFee;

    Object.keys(customFeeById).forEach((feeId: any) => {
      dataOfPriceCopy.push(customFeeById[feeId]);
    });

    setdataOfPrice([...dataOfPriceCopy]);
  }, [
    summaryData,
    subTotal,
    bundleData,
    selectedCoupon,
    discount,
    couponCode,
    shippingSelection,
  ]);

  useEffect(() => {
    const newTotal = dataOfPrice.reduce((inti: any, curr: any) => {
      return (
        Number(parseFloat(curr.price).toFixed(2)) +
        Number(parseFloat(inti).toFixed(2))
      );
    }, 0);
    setTotalFee(newTotal);
  }, [dataOfPrice]);

  let initialValuesData: any = {
    couponCode: "",
  };

  const [CouponApi, { response: getResponse, error: couponError }] = useFetch(
    `/public-coupon/${idOfStore}/${couponCode}`,
    {
      method: "get",
    }
  );
  useEffect(() => {
    if (couponCode) {
      CouponApi();
    }
  }, [couponCode]);

  useEffect(() => {
    let subTotalCopy = totalAmount;
    if (selectedCoupon?.type === 1 || selectedCoupon?.type === 2) {
      if (couponCode !== "") {
        subTotalCopy =
          Number(subTotalCopy) - Number(DiscountAmount.price) > 0
            ? Number(subTotalCopy) - Number(DiscountAmount.price)
            : 0;
      } else {
        subTotalCopy = totalAmount;
      }
    } else {
      subTotalCopy = totalAmount;
    }
    setsubTotal(subTotalCopy);
    const total = Number(totalFee) + Number(subTotalCopy);
    if (selectedCoupon?.type === 3 || selectedCoupon?.type === 4) {
      if (couponCode !== "") {
        setGrandTotal(
          Number(total) - Number(DiscountAmount.price) > 0.5
            ? Number(total) - Number(DiscountAmount.price)
            : 0
        );
        setGrandTotalCopy(
          Number(total) - Number(DiscountAmount.price) > 0
            ? Number(total) - Number(DiscountAmount.price)
            : 0
        );
      } else {
        setGrandTotal(total);
        setGrandTotalCopy(total);
      }
    } else {
      setGrandTotal(total);
      setGrandTotalCopy(total);
    }
    setdataOfPrice((prev: any) => {
      const dataOfPriceCopy: any = [...prev];
      if (summaryData.tax_type === 1 || summaryData.tax_type === 2) {
        dataOfPriceCopy[0] = {
          ...dataOfPriceCopy[0],
          price: (summaryData.tax * subTotalCopy) / 100,
        };
      }
      const canChargeProcessingFee =
        summaryData?.is_charge_processing_fee_type === 1 &&
        (summaryData?.payment_handle_type === 1 ||
          (summaryData?.payment_handle_type === 3 &&
            bundleData?.find((item: any) => item?.isSingleProduct) !== undefined));
      if (canChargeProcessingFee && dataOfPriceCopy[2]) {
        dataOfPriceCopy[2] = {
          ...dataOfPriceCopy[2],
          price: calcProcessingFee(
            subTotalCopy,
            getProcessingFeeLineCount(bundleData || [])
          ),
        };
      }
      return dataOfPriceCopy;
    });
  }, [totalFee, subTotal, couponCode, selectedCoupon]);

  useEffect(() => {
    if (getResponse && getResponse?.status === 1) {
      toast.success("Coupon applied successfully");
      setShowDiscountTab(true);
      setSelectedCoupon(getResponse.data);
      setCouponId(getResponse.data.id);

      if (getResponse?.data?.type === 1) {
        DiscountAmount.price = `${getResponse?.data.amount}`;
        // setsubTotal(
        //   Number(subTotal) - Number(DiscountAmount.price) > 0
        //     ? Number(subTotal) - Number(DiscountAmount.price)
        //     : 0
        // );
      } else if (getResponse?.data?.type === 2) {
        DiscountAmount.price = (getResponse?.data.amount * subTotal) / 100;
        // setsubTotal(
        //   Number(subTotal) - Number(DiscountAmount.price) > 0
        //     ? Number(subTotal) - Number(DiscountAmount.price)
        //     : 0
        // );
      } else if (getResponse?.data?.type === 3) {
        DiscountAmount.price = `${getResponse?.data.amount}`;
        // setGrandTotal(
        //   Number(grandTotal) - Number(DiscountAmount.price) > 0
        //     ? Number(grandTotal) - Number(DiscountAmount.price)
        //     : 0
        // );
      } else if (getResponse?.data?.type === 4) {
        DiscountAmount.price =
          (Number(getResponse?.data.amount) * Number(grandTotal)) / 100;
        // setGrandTotal(
        //   Number(grandTotal) - Number(DiscountAmount.price) > 0
        //     ? Number(grandTotal) - Number(DiscountAmount.price)
        //     : 0
        // );
      }
      setLoaderApplyCoupon(false);
      setDiscount(DiscountAmount);
    } else if (getResponse && getResponse?.status !== 1) {
      // toast.error(getResponse?.message);
      setLoaderApplyCoupon(false);
    } else {
      setDiscount(subTotal);
      setShowDiscountTab(false);
      setLoaderApplyCoupon(false);
    }
  }, [getResponse]);

  useEffect(() => {
    if (couponError) {
      // toast.error(couponError?.message);
      formik.setFieldError("couponCode", couponError?.message);
      setLoaderApplyCoupon(false);
    }
  }, [couponError]);

  const formik = useFormik({
    initialValues: initialValuesData,
    validationSchema: couponCodeFormSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      setCouponCode("");
      setLoaderApplyCoupon(true);
      setTimeout(() => {
        const valCopy = values.couponCode;
        setCouponCode(valCopy);
      }, 1000);
    },
  });
  const handleRemoveCouponCode = () => {
    DiscountAmount.price = "0.00";
    setDiscount({
      name: "Discount",
      price: "0.00",
    });
    setShowDiscountTab(false);
    setCouponCode("");
    setCouponId(0);
    setSelectedCoupon(null);
    formik.resetForm();
  };

  return (
    <>
      <Grid className={styles.CheckoutCartOrderSummary}>
        <p className={styles.CheckoutCartOrderSummaryHeading}>Order Summary</p>
        {hasPendingStoreChanges ? (
          <p className={noteStyles.checkoutHint}>
            Some items changed since they were added. Accept the changes or remove those items before placing the order.
          </p>
        ) : null}
        {orderSummaryEntries.map((entry: any) =>
          entry.kind === "bundle" ? (
            <ComplexGrid
              key={`summary-bundle-${entry.index}`}
              cartIndex={entry.index}
              cartItem={entry.item}
              attachedSingles={entry.attachedSingles || []}
              bundleDisplayLabel={getBundleDisplayLabel(bundleData, entry.item)}
              reLoadCart={reLoadCart}
              setReLoadCart={setReLoadCart}
              storeChange={storeChanges[String(entry.item?.cartLineId)] || null}
              onAcceptChanges={() => acceptStoreChange(entry.item?.cartLineId)}
              onRemoveChangedItem={() => removeChangedItem(entry.item?.cartLineId)}
            />
          ) : (
            <ComplexGrid
              key={`summary-standalone-${entry.index}`}
              cartIndex={entry.index}
              cartItem={entry.item}
              includedInBundleText={getIncludedInBundleText(
                bundleData,
                entry.item?.parentBundleLineId
              )}
              reLoadCart={reLoadCart}
              setReLoadCart={setReLoadCart}
              storeChange={storeChanges[String(entry.item?.cartLineId)] || null}
              onAcceptChanges={() => acceptStoreChange(entry.item?.cartLineId)}
              onRemoveChangedItem={() => removeChangedItem(entry.item?.cartLineId)}
            />
          )
        )}
        {showDiscountTab === true && selectedCoupon ? (
          <div className={styles.appliedCoupon}>
            <div className={styles.couponAppliedWrapper}>
              <div className={styles.couponCode}>
                <b>{selectedCoupon.coupon_code}</b> applied
              </div>
              <div className={styles.discountPrice}>
                {selectedCoupon.type === 1
                  ? `FLAT $${selectedCoupon.amount} from subtotal`
                  : selectedCoupon.type === 2
                    ? `${selectedCoupon.amount}% from the subtotal`
                    : selectedCoupon.type === 3
                      ? `FLAT $${selectedCoupon.amount} from grand total`
                      : `${selectedCoupon.amount}% from the grand total`}
              </div>
            </div>
            <div className={styles.removeCoupon}>
              <AppButton
                onClick={() => {
                  handleRemoveCouponCode();
                }}
              >
                Remove
              </AppButton>
            </div>
          </div>
        ) : (
          <form onSubmit={formik.handleSubmit}>
            <Grid container className={styles.couponWrapper}>
              <Grid item lg={8} xs={7}>
                <InputField
                  formik={formik}
                  label="Coupon or Gift Card"
                  placeholder="Type code here"
                  name="couponCode"
                />
              </Grid>
              <Grid className={styles.couponBtn} item lg={3} xs={4}>
                <AppButton
                  disabled={
                    formik.values.couponCode === "" ||
                    !formik.values.couponCode.replace(/\s/g, "").length ||
                    loaderApplyCoupon
                  }
                  type="submit"
                >
                  Apply{" "}
                  {loaderApplyCoupon ? (
                    <span
                      className="loadingBars"
                      style={{ display: "flex", marginRight: "5px" }}
                    >
                      <RotatingLines
                        strokeColor="currentColor"
                        strokeWidth="5"
                        animationDuration="0.75"
                        width="20"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </AppButton>
              </Grid>
            </Grid>
          </form>
        )}

        {Number(summaryData?.is_offer_rush_shipping || 0) === 1 && (
          <div className={styles.shippingSelection}>
            <div className="form_control">
              <InputLabel className="form_label" htmlFor="shipping-selection">
                Shipping Selection
              </InputLabel>
              <div className="input_field_wrap">
                <FormControl size="small" fullWidth>
                  <Select
                    id="shipping-selection"
                    name="shippingSelection"
                    value={shippingSelection}
                    onChange={(e) =>
                      setShippingSelection(e.target.value as string)
                    }
                    className="form_select"
                    variant="outlined"
                    MenuProps={{ className: "form_select_list" }}
                    IconComponent={KeyboardArrowDown}
                  >
                    <MenuItem value="1">
                      {Number(summaryData?.shipping_fee_type) === 0
                        ? "No Shipping"
                        : Number(summaryData?.shipping_fee_type) === 2
                          ? `Standard Shipping (${Number(
                              summaryData?.shipping_amount || 0
                            )}%)`
                          : `Standard Shipping ($${Number(
                              summaryData?.shipping_amount || 0
                            ).toFixed(2)})`}
                    </MenuItem>
                    <MenuItem value="2">
                      {`Rush Shipping ($${Number(
                        summaryData?.rush_shipping_fee || 0
                      ).toFixed(2)})`}
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
        )}

        <div className={styles.priceWrapper}>
          <div className={styles.singlePrice}>
            <div className={styles.left}>
              <b>Subtotal</b>
            </div>

            <div className={styles.right}>
              {storeData.is_price_hide !== 1 &&
              storeData.payment_handle_type !== 2 ? (
                <b>{`$${parseFloat(totalAmount.toString()).toFixed(2)}`}</b>
              ) : (
                <b>{`$0.00`}</b>
              )}
            </div>
          </div>

          {/* <div className={styles.singlePrice}>
            <div className={styles.left}>
              <b>Subtotal After Discount</b>
            </div>

            <div className={styles.right}>
              <b>{`$${parseFloat(subTotal.toString()).toFixed(2)}`}</b>
            </div>
          </div> */}

          {(selectedCoupon?.type === 1 || selectedCoupon?.type === 2) &&
          showDiscountTab == true ? (
            <div className={styles.singlePrice}>
              <div className={styles.left}>
                <b>{discount.name}</b>
              </div>

              <div className={styles.right}>
                {storeData.is_price_hide !== 1 &&
                storeData.payment_handle_type !== 2 ? (
                  <b>
                    -{" "}
                    {discount?.price
                      ? `$${parseFloat(discount.price.toString()).toFixed(2)}`
                      : ""}
                  </b>
                ) : (
                  <b>{`$0.00`}</b>
                )}
              </div>
            </div>
          ) : (
            ""
          )}
          {/* <h1>{dataOfPrice.length}</h1> */}
          {dataOfPrice.map((val: any, index: any) => {
            // if(data.value === 1 && val.name ==="Shipping Fee" )
            const rushSelected =
              Number(summaryData?.is_offer_rush_shipping || 0) === 1 &&
              shippingSelection === "2";
            if (
              (val.name === "Shipping Fee" && (!showShipping || rushSelected)) ||
              (!showProcessingFee && val.name === "Processing Fee") ||
              (val.name === "Rush Shipping Fee" && !showRushShipping)
            ) {
            } else {
              return (
                <div className={styles.singlePrice}>
                  <div className={styles.left}>{val.name}</div>
                  {storeData.is_price_hide !== 1 &&
                  storeData.payment_handle_type !== 2 ? (
                    <div className={styles.right}>{`$${parseFloat(
                      val.price.toString()
                    ).toFixed(2)}`}</div>
                  ) : (
                    <div className={styles.right}>{`$0.00`}</div>
                  )}
                </div>
              );
            }
          })}
          {(selectedCoupon?.type === 3 || selectedCoupon?.type === 4) &&
          showDiscountTab == true ? (
            <div className={styles.singlePrice}>
              <div className={styles.left}>
                <b>{discount.name}</b>
              </div>

              <div className={styles.right}>
                {storeData.is_price_hide !== 1 &&
                storeData.payment_handle_type !== 2 ? (
                  <b>
                    -{" "}
                    {discount?.price
                      ? `$${parseFloat(discount.price.toString()).toFixed(2)}`
                      : ""}
                  </b>
                ) : (
                  <b>{`$0.00`}</b>
                )}
              </div>
            </div>
          ) : (
            ""
          )}
          <div className={styles.singlePrice}>
            <div className={styles.left}>
              <b>
                Grand Total{" "}
              </b>
              {isPerBundleFeeApplied ? (
                  <span
                    style={{
                      color: "#d32f2f",
                      fontSize: "10px",
                      display: "inline-flex",
                      alignItems: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    (Fees are applied for {bundleCount}{" "}
                    {bundleCount > 1 ? "bundles" : "bundle"})
                  </span>
                ) : null}
            </div>

            <div className={styles.right}>
              {storeData.is_price_hide !== 1 &&
              storeData.payment_handle_type !== 2 ? (
                <b>
                  {showDiscountTab == true && Number(grandTotal) < 0.5
                    ? "$0.00"
                    : `$${parseFloat(grandTotal.toString()).toFixed(2)}`}
                </b>
              ) : (
                <b>{`$0.00`}</b>
              )}
            </div>
          </div>
        </div>
        {/* {showPlaceOrder && (
          <div className={styles.orderButton}>
            <AppButton onClick={placeOrder} variant="outlined">
              Place Order
            </AppButton>
          </div>
        )} */}
      </Grid>
    </>
  );
};

export default CheckoutOrderSummary;
